'use client';

import { CurrencyTabs } from '@wwe-portal/ui/features/store-revamp/currency-tabs';
import { useCurrentCurrency } from '@wwe-portal/web/hooks/global/use-current-currency';

export const CurrencySwitch = () => {
  const { currency, changeCurrency, currencies } = useCurrentCurrency();
  const globalCurrencies = currencies?.filter((item) => item.typeId === 2);
  if (globalCurrencies == null || globalCurrencies?.length < 2) return null;
  const tabs = globalCurrencies.map((c) => ({
    value: String(c.id),
    content: c.name,
  }));

  return (
    <CurrencyTabs
      tabs={tabs}
      value={String(currency?.id)}
      onChange={function (value: string): void {
        changeCurrency(Number(value));
      }}
      isNew={false}
    />
  );
};
